import { DataImportFileFilters } from '@/api/requests/import/data-import-file-filters';
import { DataImportFiles } from '@/api/responses/import/data-import-files';
import { State } from '@/stores/import/state';
import { MutationTree } from 'vuex';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setDataImportFiles = (state: State, payload: DataImportFiles) => {
        state.dataImportFiles = payload.files;
        state.totalDataImportFiles = payload.total;
    }

    public setDataImportFileFilters = (state: State, payload: DataImportFileFilters) => {
        state.filters = { ...payload };
    }
}
